export default {
    poweredBy: "Distribuído por"
}